<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Ship Owner Company" subTitle="Forms" />

    <ListShipOwnerCompany />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import ListShipOwnerCompany from "@/components/Pages/Master/ShipOwnerCompany/ListShipOwnerCompany.vue";

export default defineComponent({
  name: "ListShipOwnerCompanyPage",
  components: {
    PageTitle,
    ListShipOwnerCompany,
  },
});
</script>
